import actions from '@/store/companyPages/actions';

const companyPagesModule = {
  state: () => ({
    companyPages: [],
    companyPagesTotal: 0,
    isCompanyPagesLoaded: true,
    currentCompanyPage: null,
    isCurrentCompanyPageLoaded: false,
    lastLoadedCompanyId: null,
    // Draft of the currently selected page (null if no draft exists)
    currentDraft: null,
  }),
  getters: {
    sortedCompanyPages(state) {
      return [...(state.companyPages || [])].sort((a, b) => a.footerOrder - b.footerOrder);
    },
  },
  mutations: {
    GET_COMPANY_PAGES_REQUEST(state) {
      state.isCompanyPagesLoaded = false;
    },
    GET_COMPANY_PAGES_SUCCESS(state, { data, total, companyId }) {
      state.companyPages = data || [];
      state.companyPagesTotal = Number(total) || 0;
      state.isCompanyPagesLoaded = true;
      state.lastLoadedCompanyId = companyId;
    },
    GET_COMPANY_PAGES_ERROR(state) {
      state.isCompanyPagesLoaded = true;
    },
    CLEAR_COMPANY_PAGES_CACHE(state) {
      state.lastLoadedCompanyId = null;
    },
    GET_COMPANY_PAGE_REQUEST(state) {
      state.isCurrentCompanyPageLoaded = false;
    },
    GET_COMPANY_PAGE_SUCCESS(state, page) {
      state.currentCompanyPage = page;
      state.isCurrentCompanyPageLoaded = true;
    },
    GET_COMPANY_PAGE_ERROR(state) {
      state.isCurrentCompanyPageLoaded = true;
    },
    SET_CURRENT_DRAFT(state, draft) {
      state.currentDraft = draft;
    },
    CLEAR_CURRENT_DRAFT(state) {
      state.currentDraft = null;
    },
  },
  actions,
  namespaced: true,
};

export default companyPagesModule;
